<div class="footerContainer">
    <footer>
        <div class="container">
            <div class="copyrights">
                <span>© {{currentYear}} L&T EduTech. All rights reserved</span>
            </div>
            <div class="powered">
                <h1><span>Powered by </span>L&T EduTech</h1>
            </div>
        </div>
    </footer>
</div>
